export default __webpack_public_path__ + "d4a4d7b033f5ad8d72611239519d2862.png";